const styles = (theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    gap: 1.2,
    padding: "14px",
    borderRadius: "16px",
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 1.2,
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: "12px",
    fontSize: "0.8rem",
    fontWeight: "bold",
    color: theme.palette.white.main,
  },
  icon: {
    fontSize: "19px",
    color: theme.palette.white.main,
  },
  iconImage: {
    width: "20px",
    height: "20px",
    objectFit: "contain",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    flexShrink: 0,
    overflow: "hidden",
  },
  titleBox: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
  title: {
    fontWeight: 600,
    fontSize: "0.95rem",
    textTransform: "capitalize",
  },
  subtitle: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 0.3,
    flexShrink: 0,
  },
  divider: {
    my: 0,
  },
  condicao: {
    margin: 0,
    fontFamily: "monospace",
    fontSize: "0.75rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    maxHeight: "110px",
    overflowY: "auto",
    padding: "10px",
    borderRadius: "10px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
});

export default styles;
